// apps/codeframe/src/render/stampDomCfIds.ts

/**
 * Stamp `data-cf-id` onto every element inside a live DOM root that lacks one,
 * in document order, skipping any value already in use (collision-free, like
 * `injectCfNodeIds` but for a mounted React tree). Existing ids are preserved,
 * so re-stamping after a re-render keeps stable targets for nodes that persist.
 *
 * Used by TsxRenderer: React output carries no cf-ids, so motion / node-picker
 * can't address it until we stamp the rendered DOM. The container `root` itself
 * is not stamped — only its descendants (the actual rendered elements).
 */
export function stampDomCfIds(root: HTMLElement): void {
  const used = new Set<string>();
  root.querySelectorAll('[data-cf-id]').forEach((el) => {
    const id = el.getAttribute('data-cf-id');
    if (id) used.add(id);
  });
  let counter = 0;
  const fresh = (): string => {
    let id = `cf-${counter++}`;
    while (used.has(id)) id = `cf-${counter++}`;
    used.add(id);
    return id;
  };
  root.querySelectorAll<HTMLElement>('*').forEach((el) => {
    if (!el.hasAttribute('data-cf-id')) el.setAttribute('data-cf-id', fresh());
  });
}
